import { render, staticRenderFns } from "./player-mascot-registration-error.vue?vue&type=template&id=3d571172&scoped=true&lang=pug"
import script from "./player-mascot-registration-error.vue?vue&type=script&setup=true&lang=js"
export * from "./player-mascot-registration-error.vue?vue&type=script&setup=true&lang=js"
import style0 from "./player-mascot-registration-error.vue?vue&type=style&index=0&id=3d571172&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d571172",
  null
  
)

export default component.exports